import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './authentication.serivce';
import { UrlHelperService } from './url-helper.service';
import { Observable, lastValueFrom } from 'rxjs';

@Injectable()
export class ProfilePictureService {

  constructor(private http: HttpClient, private auth: AuthenticationService, private url: UrlHelperService) { }

  async get(): Promise<string> {
    try {
      var session = this.auth.getSession();
      var userId = session?.userId;

      var fallbackPath = "/assets/images/user.png";
      var path: string = "/assets/images/user/" + userId + ".png";

      var localData: string | void | undefined;
      try {
        localData = await lastValueFrom(this.getLocalImage(path));
      } catch {
        localData = undefined;
      }

      if (localData !== undefined && localData.length > 0) {
        return path;
      }

      var remotePath: string | undefined;
      try {
        remotePath = await lastValueFrom(this.getRemotePath(userId));
      } catch {
        remotePath = undefined;
      }
      
      if (remotePath !== undefined && remotePath.length > 0) {
        return remotePath;
      }

      return fallbackPath;

    } catch (err) {
      return "";
    }
  }

  private getLocalImage(path: string): Observable<string> {
    return this.http.get(path, { responseType: 'text' });
  }

  private getRemotePath(userId: number | undefined): Observable<string> {
    return this.http.get(this.url.getApiUrl() + "User/GetProfilePicture/userID=" + userId, { responseType: 'text' });
  }
}
